import { EntityQueueDefinition } from '@jms/model';
import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import { QueueTransferOwnershipDialogComponent } from './queue.transfer.ownership.dialog.component';

/** One opener so the row menu and any future header action size the modal the same way. */
export function openQueueTransferOwnershipDialog(dialogs: WorkBuddyDialogService, queue: EntityQueueDefinition): void {

  void dialogs.modal(QueueTransferOwnershipDialogComponent, {
    inputs: { queue },
    width: 'min(480px, calc(100vw - 48px))',
  });
}
